const home = {
  eyebrow: 'TOF Persona Team',
  heroTitle: 'Your profile starts in the app.',
  heroTitleAccent: 'Your team comes together here.',
  heroLead:
    'Everyone on the team takes the test in the TOF Persona app. This is where you see what those profiles say together: the working styles in your team, where the energy is and where things rub.',

  // Opens the code window.
  ctaTeamEnvironment: 'I have an access code',
  // To /quiz, which is the store screen on the web.
  ctaApp: 'Take the test in the app',

  offerCard: {
    eyebrow: 'For yourself',
    title: 'The TOF Persona app',
    text: 'Your own profile: how you work, what gives you energy and what you need. Got a team code? Then add it to your team afterwards.',
  },

  teamCard: {
    eyebrow: 'For your team',
    titleLine1: 'Your team works.',
    titleLine2: 'But does it work together?',
    text: 'See what Team Insight and Team Dynamics reveal about your team — and, if you want to look further, the Organisational Landscape and the Strategic Compass.',
  },

  footer: {
    logoAlt: 'TOF logo',
    body: 'TOF Persona was developed by The Office Factory, which looks at workplace, digital tools and behaviour as one whole.',
    website: 'Visit tof.services →',
    contact: 'Book a conversation',
    privacy:
      '🔒 Data is used anonymously for analysis and is never shared with third parties. Your name is optional.',
    // App mode: nothing goes to a server, so the web sentence is untrue there.
    privacyNative:
      '🔒 Everything stays on your device. Your answers and your profile are never sent to a server or shared with anyone. Your name is optional.',
  },

  lock: {
    eyebrow: 'Team space',
    title: 'Enter your access code',
    body: 'The team space is only accessible with a personal access code.',
    placeholder: 'Enter code',
    errorEmpty: 'Please enter an access code first',
    errorCheck: 'Something went wrong while checking the code',
    errorUnknown: 'Incorrect or unknown code',
    checking: 'Checking...',
    submit: 'Continue',
    close: 'Close',
  },
};

export default home;
